const VariationChipStyle = {
    root: {
        margin: "0.2rem",
    }
}

export default VariationChipStyle;